const persistStore = store => next => action => {
  const result = next(action);
  localStorage.signupFlowState = JSON.stringify(store.getState());
  return result;
};

export default persistStore;



/** WEBPACK FOOTER **
 ** ./src/_shared/middleware/persistStore.js
 **/